import React from 'react'
import CustomModal from './CustomModal';
import { KonfhubButton } from '../Buttons';

const MultipleOptionAddingModal = ({
    header,
    openTextAreaModal,
    setOpenTextAreaModal,
    multipleOptionsValues,
    onChange,
    closeButton,
    saveButton,
    closeButtonText,
    saveButtonText,
    handleSave
}) => {
    return (
        <>
            <CustomModal
                header={header}
                openModal={openTextAreaModal}
                setOpenModal={() => {
                    setOpenTextAreaModal(false);
                }}
                headerStyle={{ textAlign: "left" }}
                noClose={false}
                content={
                    <>
                        <div className="w-100 d-flex flex-column align-items-end justify-content-end px-3 py-2 textarea-option-wrapper">
                            <textarea
                                name="postContent"
                                className="textarea-option w-100"
                                placeholder="Enter each tag in&#10;a new line&#10;like this"
                                value={multipleOptionsValues}
                                onChange={(e) => onChange(e.target.value)}
                            />
                        </div>
                        <div className="w-100 d-flex justify-content-end">
                            {closeButton && <KonfhubButton
                                btnType="secondary"
                                className="mt-3"
                                onClick={() => {
                                    setOpenTextAreaModal(false);
                                }}
                            >
                                {closeButtonText}
                            </KonfhubButton>
                            }
                            {saveButton &&
                                <KonfhubButton
                                    className="mt-3 ml-2"
                                    onClick={() => {
                                        handleSave()
                                    }}
                                >
                                    {saveButtonText}
                                </KonfhubButton>}
                        </div>
                    </>
                }
            />
            <style jsx>{`
                .textarea-option-wrapper {
					border: 1px solid #C3CDDF;
				}
				.textarea-option {
					resize: none;
					outline: none;
					border: none;
					height: 400px;
					width: 500px !important;
					padding: 5px;
				}
			`}</style>
        </>
    )
}

export default MultipleOptionAddingModal